<template>
<div>
	<labour-report></labour-report>
	<!--<collapsible-panel :always-open="true" panel-size="sm">
		<template slot="panel">
			<h5>Reports</h5>

			<panel-menu 
				:menu-items="reportTabs"
				:active-item="activeSection"
				v-on:itemClick="activateSection">
			</panel-menu>
		</template>
		<template slot="main">
			<h2>
				{{activeSection}} Report<br>
				<small>Project #{{$store.project.job_num}}, {{$store.project.job_name}}</small>
			</h2>

			<labour-report v-if="activeSection == 'Labour Progress'"></labour-report>

			<materials-report v-else-if="activeSection == 'Materials Used'"></materials-report>
			
		</template>
	</collapsible-panel>
	-->
</div>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"
import LabourReport from "@/pages/project/project_tabs/reports/LabourReport"
//import MaterialsReport from "@/pages/project/project_tabs/reports/MaterialsReport"

export default {
	name: "ProjectReports",
	components: {
		Widget,
		CollapsiblePanel,
		PanelMenu,
		LabourReport,
		//MaterialsReport
	},
	mixins: [],
	data() {
		return {
			activeSection: "",
			reportTabs: [
				"Labour Progress",
				"Materials Used"
			],
		}
	},
	computed: {
		
	},
	methods: {
		activateSection(item) {
			this.activeSection = item
			window.history.pushState({},"","/project/"+this.$route.params.id+"/reports/"+item.slugify())
		},
		fetchData() {
			let vm = this

			let promises = []

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)
				
			})
		}
	},
	created() {
		//this.fetchData()

		let segments = this.segmentUrl(window.location.href)
		let tab = segments[3]
		let tag = segments[4]

		if (this.$route.params.tag || tag) {
			let slug = this.$route.params.tag ? this.$route.params.tag : tag

			this.activeSection = this.reportTabs.find(section => section.slugify() == slug)

		}
	}
}
</script>

<style type="text/css" scoped>
	.handle {
		cursor: pointer;
	}

	.totals {
		font-weight: bold;
	}
</style>